// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!./edit.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, "._8c65ec{}.e1c490{max-width:7.5em}.fdefe3{width:7.25em;min-width:7.25em;font-weight:600 !important}._421c45{display:flex;justify-content:center}._421c45>*{margin-top:0 !important}._47c309{line-height:1;font-size:.875em;max-height:14em !important;font-weight:500;min-width:6em}._47c309>*{justify-content:center}._47c309::-webkit-scrollbar{width:3px}._47c309+._47c309{margin-left:1.125em !important}", ""]);
// Exports
exports.locals = {
	"edit": "_8c65ec " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["edit"] + "",
	"input": "e1c490",
	"tag": "fdefe3",
	"columns": "_421c45",
	"menu": "_47c309"
};
module.exports = exports;
